import { useState } from "react";
import { useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function LoadPlayModal (props)
{
    const gDispatch = useDispatch();

    function hide () { props.hide(); }
    function newPlay () { props.newPlay(); }
    function loadPlay () { props.loadPlay(); }
    
    return (
	<Modal
	    show={props.show}
	    onHide={hide}
	    centered
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title>Partie en cours...</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<p className="fw-medium">Attention&nbsp;: si vous lancez une nouvelle partie, vous perdrez toute progression sauvegardée lors de votre partie en cours.</p>

		<div className="d-flex flex-column gap-2">
		    <Button variant="success" onClick={loadPlay}>Continuer la partie</Button>
		    <Button variant="danger" onClick={newPlay}>Recommencer de zéro</Button>
		</div>
	    </Modal.Body>
	</Modal>
    );
}

